export default __webpack_public_path__ + "static/media/box-SVG.31eca8b7.svg";